<template>
  <v-container>
    <div class="form-npa m-t-40 private-pg">
      <div class="position">
        <div class="bg-white p-20">
          <v-form
            action
            enctype="multipart/form-data"
            ref="createForm"
            @submit.prevent="createNpa"
          >
            <div class="form-head">
              <Widget position="menu_profile" />
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                          dark
                          v-on="on"
                          class="navbar-toggler-profile"
                  >
                    {{ $t("Профиль") }} <span class="caret"></span>
                  </v-btn>
                </template>
                <v-list class="navbar-collapse">
                  <v-list-item>
                    <Widget position="menu_profile" />
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="form-body">
              <div class="form-col-2">
                <div
                  class="form-group"
                  :class="{
                    invalid: $v.npa.nameKg.$error
                  }"
                >
                  <label for="npa_nameKg">
                    {{ $t("Наименование на государственном языке") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <v-text-field
                    id="npa_nameKg"
                    v-model="npa.nameKg"
                    outlined
                    rounded
                    dense
                    name="npa[nameKg]"
                  />
                </div>

                <div
                  class="form-group"
                  :class="{
                    invalid: $v.npa.name.$error
                  }"
                >
                  <label for="npa_name">
                    {{ $t("Наименование на официальном языке") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <v-text-field
                    id="npa_name"
                    v-model="npa.name"
                    outlined
                    rounded
                    dense
                    name="npa[name]"
                  />
                </div>

                <div
                  class="form-group"
                  :class="{ invalid: $v.npa.view.$error }"
                >
                  <label for="npa_view">
                    {{ $t("Вид проекта НПА") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <v-select
                    id="npa_view"
                    item-value="id"
                    item-text="transName"
                    v-model="npa.view"
                    :items="npaDataArray.refNpaView"
                    input="transName"
                    outlined
                    rounded
                    dense
                    :disabled="isInitiativeGroupUser"
                    @change="changeNpaView($event)"
                  />
                </div>

                <div
                  class="form-group"
                  v-if="npa.view === npaDataArray.npaViewId"
                >
                  <label for="npa_region">
                    {{ $t("Область") }}
                    <fieldInfo />
                  </label>
                  <v-select
                    id="npa_region"
                    return-object
                    item-text="transName"
                    v-model="npa.region"
                    :items="npaDataArray.refRegions"
                    input="transName"
                    outlined
                    rounded
                    dense
                  />
                </div>

                <div class="form-group" v-if="npa.view === npaDataArray.npaViewId">
                  <label for="npa_district">
                    {{ $t("Район") }}
                    <fieldInfo />
                  </label>
                  <v-select
                    id="npa_district"
                    item-value="id"
                    item-text="transName"
                    v-model="npa.district"
                    :items="npa.region.districts"
                    :disabled="!npa.region"
                    input="transName"
                    outlined
                    rounded
                    dense
                  />
                </div>

                <div
                  class="form-group"
                  :class="{ invalid: $v.npa.edition.$error }"
                >
                  <label for="npa_edition">
                    {{ $t("Редакция") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <div class="select-def">
                    <v-select
                      id="npa_edition"
                      item-value="id"
                      item-text="transName"
                      v-model="npa.edition"
                      :items="npaDataArray.refNpaEdition"
                      input="transName"
                      outlined
                      rounded
                      dense
                    />
                  </div>
                </div>

                <div
                  class="form-group"
                  :class="{
                    invalid: $v.npa.developer.$error
                  }"
                  v-if="npaDataArray.isAdmin || isInitiativeGroupUser"
                >
                  <label for="npa_developer">
                    {{ $t("Разработчик проекта НПА") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <div class="select-def">
                    <v-autocomplete
                      id="npa_developer"
                      item-value="id"
                      item-text="transName"
                      v-model="npa.developer"
                      :items="npaDataArray.refDeveloper"
                      input="transName"
                      outlined
                      rounded
                      dense
                      :disabled="isInitiativeGroupUser"
                    />
                  </div>
                </div>

                <div
                  v-if="viewIdsCompare"
                  class="form-group"
                >
                  <label for="npa_initiator">
                    {{ $t("Инициатор проекта НПА") }}
                    <fieldInfo />
                  </label>
                  <div class="select-def">
                    <v-select
                      id="npa_initiator"
                      item-value="id"
                      item-text="transName"
                      v-model="npa.initiator"
                      :items="npaDataArray.refInitiator"
                      input="transName"
                      :disabled="isInitiativeGroupUser"
                      outlined
                      rounded
                      dense
                    />
                  </div>
                </div>
                <div
                  class="form-group"
                  :class="{
                    invalid: $v.npa.persons.$error
                  }"
                >
                  <label for="npa_developer">
                    {{ $t('Контактные лица') }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <div class="select-def">
                    <ContactPersons
                      v-model="npa.persons"
                      ref="persons"
                      @fetchPersons="getDataPersons($event)"
                      :persons-length="npa.persons ? npa.persons.length : 0"
                    />
                    <ul class="">
                      <li v-for="(person, index) of npa.persons" :key="index">
                        <div>
                          {{ index + 1 }}. {{ person.fullName }}
                          {{ person.position }} {{ person.phone }}
                          <span
                            class="pro-icon-close"
                            @click="deletePerson(index)"
                          ></span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="form-group"
                  :class="{
                    invalid: $v.npa.category.$error
                  }"
                >
                  <label>
                    {{ $t("Категории") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <NpaCategories
                    @fetchTags="getDataBranchLaw($event)"
                    @selectedCategories="getDataCategory($event)"
                  />
                </div>

                <div
                  class="form-group"
                  :class="{ invalid: $v.npa.publishDate.$error }"
                >
                  <label>
                    {{ $t("Дата публикации проекта НПА") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <div class="form-date">
                    <v-menu
                      v-model="datemenu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          id="npa_publishDate"
                          v-model="npa.publishDate"
                          readonly
                          v-on="on"
                          outlined
                          rounded
                          dense
                          name="npa[publishDate]"
                        />
                      </template>
                      <v-date-picker
                        v-model="npa.publishDate"
                        @input="datemenu1 = false"
                        no-title
                        :weekday-format="getDay"
                        :month-format="getMonthFormat"
                        :header-date-format="getHeaderDateFormat"
                        first-day-of-week="1"
                        :min="nowDate"
                      />
                    </v-menu>
                  </div>
                </div>

                <div
                  class="form-group"
                  :class="{ invalid: $v.npa.discussionPeriodDateFrom.$error}"
                  v-if="!isInitiativeGroupUser"
                >
                  <label>
                    {{ $t("Период обсуждения проекта НПА") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <div class="form-date">
                    <v-row>
                      <v-col>
                        <v-menu
                          v-model="datemenu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              id="npa_discussionPeriodDateFrom"
                              v-model="npa.discussionPeriodDateFrom"
                              readonly
                              v-on="on"
                              outlined
                              rounded
                              dense
                              name="npa[discussionPeriodDateFrom]"
                            />
                          </template>
                          <v-date-picker
                            v-model="npa.discussionPeriodDateFrom"
                            @input="datemenu2 = false"
                            no-title
                            :weekday-format="getDay"
                            :month-format="getMonthFormat"
                            :header-date-format="getHeaderDateFormat"
                            first-day-of-week="1"
                            :min="nowDate"
                            @change="setMinDateForDateMenu3"
                          />
                        </v-menu>
                        <div v-if="npa.discussionPeriodDateFrom" class="mt-2">
                          <v-btn
                            small
                            rounded
                            color="primary"
                            @click="setDiscussionPeriod(10)">
                            {{$t('Сократить до 10 дней')}}
                          </v-btn>
                          <v-icon @click="showModal = true">mdi-information-outline</v-icon>
                        </div>
                        <v-dialog v-model="showModal" max-width="500px">
                          <v-card>
                            <v-card-title>{{$t('Информация')}}</v-card-title>
                            <v-card-text>
                              {{$t('Срок общественного обсуждения может быть сокращен до десяти календарных дней только в случае организации дополнительных мероприятий, направленных на повышение эффективности общественного обсуждения.')}}
                            </v-card-text>
                            <v-card-actions>
                              <v-btn color="primary" @click="showModal = false">{{$t('Закрыть')}}</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-col>
                      <v-col>
                        <v-menu
                          v-model="datemenu3"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              id="npa_discussionPeriodDateTo"
                              v-model="npa.discussionPeriodDateTo"
                              readonly
                              v-on="on"
                              outlined
                              rounded
                              dense
                              name="npa[discussionPeriodDateTo]"
                            />
                          </template>
                          <v-date-picker
                            v-model="npa.discussionPeriodDateTo"
                            @input="() => {datemenu3 = false; resetExtraMeasuresAndIsShortened()}"
                            no-title
                            :weekday-format="getDay"
                            :month-format="getMonthFormat"
                            :header-date-format="getHeaderDateFormat"
                            first-day-of-week="1"
                            :min="minDateForDateMenu3"
                            :max="maxDateForDateMenu3"
                            @change="setMaxDateForDateMenu3"
                          />
                        </v-menu>
                      </v-col>
                    </v-row>
                  </div>
                </div>
                <div
                  v-if="npa.isShortened"
                  class="form-group"
                >
                  <label for="npa_name">
                    {{ $t("Доп.мероприятия") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <v-textarea
                    solo
                    outlined
                    clearable
                    rounded
                    v-model="npa.extraMeasures"
                    required />
                </div>
              </div>

              <div class="form-col-1">
                <div
                  class="form-group npa-editor"
                  :class="{
                    invalid: $v.npa_version.textKg.$error
                  }"
                >
                  <label>
                    {{ $t("Текст проекта НПА на государственном языке") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <ckeditor
                    :editor="editor"
                    v-model="npa_version.textKg"
                    :config="editorConfig"
                  />
                </div>
                <div
                  class="form-group npa-editor"
                  :class="{
                    invalid: $v.npa_version.text.$error
                  }"
                >
                  <label>
                    {{ $t("Текст проекта НПА на официальном языке") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <ckeditor
                    :editor="editor"
                    v-model="npa_version.text"
                    :config="editorConfig"
                  />
                </div>
                <div
                  class="form-group"
                  :class="{
                    invalid: $v.npa.projectGoalKg.$error
                  }"
                >
                  <label>
                    {{ $t("Цель проекта НПА на государственном языке") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <ckeditor
                    :editor="editor"
                    v-model="npa.projectGoalKg"
                    :config="editorConfig"
                  />
                </div>
                <div
                  class="form-group"
                  :class="{
                    invalid: $v.npa.projectGoal.$error
                  }"
                >
                  <label>
                    {{ $t("Цель проекта НПА на официальном языке") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <ckeditor
                    :editor="editor"
                    v-model="npa.projectGoal"
                    :config="editorConfig"
                  />
                </div>
                <div
                  class="form-group"
                  :class="{
                    invalid: $v.npa.keyword.$error
                  }"
                >
                  <label>
                    {{ $t("Ключевые слова") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <NpaKeywords @changeKeywords="getDataKeyword($event)" />
                </div>
              </div>
            </div>
            <div class="form-bottom">
              <div class="form-group">
                <label
                  :class="{
                    invalid: $v.npa_version.uploadedFile.$error || $v.npa_version.uploadedFileKg.$error
                  }"
                >
                  {{ $t("Файлы") }}
                  <fieldInfo />
                </label>
                <div class="files">
                  <div
                    class="file-item"
                    :class="{
                      invalid: $v.npa_version.uploadedFileKg.$error
                    }"
                  >
                    <v-file-input
                      :label="$t('Загрузить файл текста проекта НПА на государственном языке')"
                      v-model="npa_version.uploadedFileKg"
                    />
                    <i v-if="npaVersionFileErrorKg" class="invalid">{{ $t("Неверный формат файла") }}</i>
                  </div>
                  <div
                    class="file-item"
                    :class="{
                      invalid: $v.npa_version.uploadedFile.$error
                    }"
                  >
                    <v-file-input
                      :label="$t('Загрузить файл текста проекта НПА на официальном языке')"
                      v-model="npa_version.uploadedFile"
                    />
                    <i v-if="npaVersionFileError" class="invalid">{{ $t("Неверный формат файла") }}</i>
                  </div>
                </div>
              </div>
              <div class="form-group" :class="{ invalid: $v.npa.npaDocuments.$error }">
                <label>{{ $t("Сопроводительные документы") }}</label>
                <Document
                  @setDataDocs="getDocsData($event)"
                  :invalid="$v.npa.npaDocuments.$error"
                  :highlight-upload-text="npa.entrepreneurshipAffect"
                />
                <i v-if="$v.npa.npaDocuments.$error" class="invalid">{{ $t("Загрузите справки-обоснования") }}</i>
                <i v-if="npaDocumentsFileError" class="invalid">{{ $t("Неверный формат файла") }}</i>
              </div>
              <div class="form-group">
                <div class="checkbox">
                  <label for="npa_fundingRequired">
                    <input
                      type="checkbox"
                      id="npa_fundingRequired"
                      name="npa[fundingRequired]"
                      v-model="npa.fundingRequired"
                      value="1"
                    />
                    <fieldInfo />
                    {{ $t("Требует финансирования") }}
                  </label>
                  <label for="npa_entrepreneurshipAffect">
                    <input
                      type="checkbox"
                      id="npa_entrepreneurshipAffect"
                      name="npa[entrepreneurshipAffect]"
                      v-model="npa.entrepreneurshipAffect"
                      value="1"
                    />
                    <fieldInfo />
                    {{ $t("Затрагивает предпринимательскую деятельность") }}
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label>
                  {{ $t("Ссылки на НПА") }}
                  <fieldInfo />
                </label>
                <NpaLinks @fetchLinks="getDataLinks($event)" />
              </div>
              <div class="form-group form-action">
                <button
                  class="btn btn-default white"
                  type="submit"
                  value="1"
                  @click="addValue($event)"
                >
                  {{ $t("Сохранить как черновик") }}
                </button>
                <button
                  class="btn btn-default blue"
                  type="submit"
                  value="2"
                  @click="addValue($event)"
                >
                  {{ $t("Опубликовать") }}
                </button>
              </div>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import Widget from '@/components/app/Widget'
import fieldInfo from '@/components/app/fieldInfo'
import NpaCategories from '@/components/npa/NpaCategories'
import NpaKeywords from '@/components/npa/NpaKeywords'
import NpaLinks from '@/components/npa/Links'
import Document from '@/components/npa/Documents'
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'
import mixin from '@/plugins/mixin/mixin'

// ckeditor
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import {Trans} from "@/plugins/Translation"
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice'
import FontFamily from '@ckeditor/ckeditor5-font/src/fontfamily'
import Font from '@ckeditor/ckeditor5-font/src/font'
import ContactPersons from '@/components/npa/ContactPersons.vue'
export default {
  mixins: [mixin],
  components: {
    Widget,
    NpaCategories,
    NpaKeywords,
    fieldInfo,
    NpaLinks,
    Document,
    ContactPersons
  },
  data: () => ({
    valid: true,
    npaDataArray: [],
    npa: {
      nameKg: '',
      name: '',
      view: '',
      edition: '',
      developer: '',
      initiator: '',
      region: '',
      district: '',
      branchLaw: [],
      category: [],
      keyword: [],
      projectGoal: '',
      projectGoalKg: '',
      fundingRequired: false,
      entrepreneurshipAffect: false,
      publishDate: '',
      discussionPeriodDateFrom: '',
      discussionPeriodDateTo: '',
      isShortened: false,
      extraMeasures: "",
    },
    npa_version: {
      text: '',
      textKg: '',
      uploadedFile: null,
      uploadedFileKg: null,
    },
    rules: {
      npa: {
        nameKg: { required },
        name: { required },
        view: { required },
        edition: { required },
        category: { required },
        keyword: { required },
        publishDate: { required },
        discussionPeriodDateFrom: { required },
        discussionPeriodDateTo: { required },
        projectGoalKg: { required },
        projectGoal: { required },
        developer: {},
        npaDocuments: {},
        persons: {}
      },
      npa_version: {
        uploadedFile: {},
        uploadedFileKg: {},
        textKg: { required },
        text: { required },
      }
    },
    datemenu1: false,
    datemenu2: false,
    datemenu3: false,
    nowDate: new Date().toISOString().slice(0, 10),
    minDateForDateMenu3: new Date().toISOString().slice(0, 10),
    maxDateForDateMenu3: null,
    editor: ClassicEditor,
    editorData: '',
    editorConfig: {
      plugins: [
        EssentialsPlugin,
        BoldPlugin,
        ItalicPlugin,
        LinkPlugin,
        ParagraphPlugin,
        HeadingPlugin,
        HorizontalLine,
        Alignment,
        Table,
        TableToolbar,
        PasteFromOffice,
        FontFamily,
        Font
      ],
      toolbar: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'alignment',
        '|',
        'horizontalLine',
        '|',
        'undo',
        'redo',
        '|',
        'insertTable',
        'fontFamily', 'fontSize',
      ],
      fontFamily: {
        options: [
          'default',
          'Times New Roman, Times, serif',
          'Arial, Helvetica, sans-serif',
          'Courier New, Courier, monospace'
        ]
      },
      table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
      },
      heading: {
        options: [
          {
            model: 'paragraph',
            title: 'Paragraph',
            class: 'ck-heading_paragraph'
          },
          {
            model: 'heading1',
            view: 'h1',
            title: 'Heading 1',
            class: 'ck-heading_heading1'
          },
          {
            model: 'heading2',
            view: 'h2',
            title: 'Heading 2',
            class: 'ck-heading_heading2'
          },
          {
            model: 'heading3',
            view: 'h3',
            title: 'Heading 3',
            class: 'ck-heading_heading3'
          }
        ]
      }
    },
    buttonValue: '',
    documentsData: [],
    links: [],
    persons: [],
    npaVersionFileError: false,
    npaVersionFileErrorKg: false,
    npaDocumentsFileError: false,
    viewIdsCompare: false,
    showModal: false,
  }),
  computed: {
    user() {
      return this.$store.state.getUser.currentUser
    },
    isInitiativeGroupUser() {
      return this.user && this.user.roleInitiativeGroupUser === true;
    }
  },
  watch: {
    isInitiativeGroupUser: {
      immediate: true,
      handler(val) {
        if (val) this.setInitiativeGroupDefaults();
      }
    },
    npaDataArray: {
      handler(val) {
        if (this.isInitiativeGroupUser && val) this.setInitiativeGroupDefaults();
      }
    },
    'npa.entrepreneurshipAffect': function(val, oldVal) {
      if (val && !oldVal) {
        this.showEntrepreneurshipHintNotification()
      }
    }
  },
  state: {
    fundingRequired: { checked: (v) => v },
    entrepreneurshipAffect: { checked: (v) => v }
  },
  validations () {
    if (this.npaDataArray.isAdmin) {
      this.rules.npa.developer = { required }
    }

    if (this.isInitiativeGroupUser) {
      this.rules.npa.discussionPeriodDateFrom = {}
      this.rules.npa.discussionPeriodDateTo = {}
    } else {
      this.rules.npa.discussionPeriodDateFrom = { required }
      this.rules.npa.discussionPeriodDateTo = { required }
    }

    if (this.buttonValue == 2) {
      this.rules.npa_version.uploadedFile = { required }
      this.rules.npa_version.uploadedFileKg = { required }
    } else {
      this.rules.npa_version.uploadedFile = {}
      this.rules.npa_version.uploadedFileKg = {}
    }
    if (this.checkLengthDocuments() === 0) {
      this.rules.npa.npaDocuments = { required }
    } else {
      this.rules.npa.npaDocuments = {}
    }

    if (this.persons.length === 0) {
      this.rules.npa.persons = { required }
    } else {
      this.rules.npa.persons = {}
    }

    return this.rules
  },
  async mounted () {
    this.npaDataArray = await this.$store.dispatch('fetchNpaData')
  },
  created() {
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    getEntrepreneurshipHintText() {
      return this.$i18n.locale === 'kg'
        ? 'Жөнгө салуучу таасирди талдоону жүктөңүз'
        : this.$t('Загрузите анализ регулятивного воздействия')
    },
    showEntrepreneurshipHintNotification() {
      if (!this.$noty || typeof this.$noty.warning !== 'function') {
        return
      }

      this.$noty.warning(this.getEntrepreneurshipHintText(), {
        killer: false,
        timeout: 3500,
        layout: 'topRight'
      })
    },
    setMinDateForDateMenu3 (v) {
      var currDate = new Date(v)
      var endDate = new Date()
      endDate.setDate(currDate.getDate() + 15);

      this.npa.discussionPeriodDateTo = endDate.toISOString().slice(0, 10)
      this.minDateForDateMenu3 = endDate.toISOString().slice(0, 10)
      this.setMaxDateForDateMenu3()
    },
    setMaxDateForDateMenu3() {
      if (!this.npa.discussionPeriodDateFrom) return null;
      const startDate = new Date(this.npa.discussionPeriodDateFrom);
      startDate.setDate(startDate.getDate() + 90);
      this.maxDateForDateMenu3 = startDate.toISOString().split("T")[0];
    },
    setDiscussionPeriod(days) {
      this.npa.discussionPeriodDateTo = this.addDays(this.npa.discussionPeriodDateFrom, days);
      if (days === 10) {
        this.npa.isShortened = true;
        this.showModal = true;
      } else {
        this.npa.isShortened = false;
        this.npa.extraMeasures = "";
      }
    },
    resetExtraMeasuresAndIsShortened() {
      this.npa.isShortened = false;
      this.npa.extraMeasures = "";
    },
    addDays(date, days) {
      let newDate = new Date(date);
      newDate.setDate(newDate.getDate() + days);
      return newDate.toISOString().substr(0, 10);
    },
    addValue (v) {
      this.buttonValue = v.target.value
    },
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    checkLengthDocuments () {
      const requiredDocuments = []
      const docTypeIds = this.npaDataArray.docTypeIds
      this.documentsData.forEach(function (element, index) {
        if (docTypeIds.includes(element.type.id)) {
          requiredDocuments.push(element.type.id)
        }
      })
      return requiredDocuments.length
    },
    createNpa () {
      console.log(this.npa)
      if (!this.validateForm()) {
        return
      }

      this.setLoading(true)

      let self = this

      try {
        const formEl = this.$refs.createForm.$el
        let fd = new FormData(formEl)

        fd = this.prepareForm(fd, 'npa', this.npa)
        fd = this.prepareForm(fd, 'npa_version', this.npa_version)

        this.documentsData.forEach(function (element, index) {
          fd.append(
            'npa[npaDocuments][' + index + '][uploadedFile]',
            element.file
          )
          fd.append(
            'npa[npaDocuments][' + index + '][description]',
            element.description
          )
          fd.append('npa[npaDocuments][' + index + '][type]', element.type.id)
        })

        this.links.forEach(function (element, index) {
          fd.append('npa[links][' + index + '][text]', element)
        })

        this.persons.forEach(function (element, index) {
          fd.append('npa[persons][' + index + '][fullName]', element.fullName)
          fd.append('npa[persons][' + index + '][position]', element.position)
          fd.append('npa[persons][' + index + '][phone]', element.phone)
        })

        const createUrl = `${Trans.currentLocale}/api/npa/create?status=${this.buttonValue}`
        if (this.npa.fundingRequired === false) {
          fd.delete('npa[fundingRequired]')
        }
        if (this.npa.entrepreneurshipAffect === false) {
          fd.delete('npa[entrepreneurshipAffect]')
        }
        if (this.npa.isShortened === false) {
          fd.delete('npa[isShortened]')
        }

        if (!this.npa.discussionPeriodDateFrom) {
          fd.delete('npa[discussionPeriodDateFrom]')
        }
        if (!this.npa.discussionPeriodDateTo) {
          fd.delete('npa[discussionPeriodDateTo]')
        }

        axios.post(createUrl, fd).then((response) => {
          this.$router.push(Trans.i18nRoute({
            name: 'npa-view',
            params: {
              id: response.data.npa
            }
          }))
          this.setLoading(false)
        }).catch((error) => {
          if (error.response) {
            if (error.response.data.npaForm || error.response.data.npaVersionForm) {
              if (error.response.data.npaForm) {
                let npaForm = error.response.data.npaForm
                let fields = npaForm.data.errors.form.children
                this.$noty.error(this.$i18n.t(npaForm.message), {
                  killer: true,
                  timeout: 1000,
                  layout: 'topRight'
                })

                for (let field in fields) {
                  if (field === 'npaDocuments') {
                    fields[field].children.forEach(function (doc) {
                      for (let docField in doc.children) {
                        if (doc.children[docField].errors) {
                          self.npaDocumentsFileError = true
                        }
                      }
                    })
                  } else if (fields[field].errors) {
                    this.rules.npa[field] = { required }
                  }
                }
              }

              if (error.response.data.npaVersionForm) {
                let npaVersionForm = error.response.data.npaVersionForm
                let npaVersionFields = npaVersionForm.data.errors.form.children

                for (let field in npaVersionFields) {
                  if (field == 'uploadedFile' && npaVersionFields[field].errors) {
                    this.npaVersionFileError = true
                  } else if (field == 'uploadedFileKg' && npaVersionFields[field].errors) {
                    this.npaVersionFileErrorKg = true
                  } else if (npaVersionFields[field].errors) {
                    this.rules.npa_version[field] = { required }
                  }
                }
              }

              this.validateForm()
            } else if (error.response.data.message) {
              this.$noty.error(this.$i18n.t(error.response.data.message), {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
            } else {
              this.$noty.error(error.message, {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
            }
          } else {
            this.$noty.error(error.message, {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          }
          this.setLoading(false)
        })
      } catch (error) {
        this.$router.push(Trans.i18nRoute({
          name: 'error',
          params: {
            status: error.response.status
          }
        }))
        this.setLoading(false)
      }
    },
    prepareForm (form, name, data) {
      for (let field in data) {
        let value = data[field]

        if (field == 'region' && data[field]) {
          value = data[field].id
        }

        if (Array.isArray(data[field])) {
          data[field].forEach(function (element) {
            form.append(`${name}[${field}][]`, element)
          })
        } else {
          form.append(`${name}[${field}]`, value)
        }
      }

      return form
    },
    getDataCategory (categoryId) {
      this.npa.category = categoryId
    },
    getDataBranchLaw (BranchLawId) {
      this.npa.branchLaw = BranchLawId
    },
    getDataKeyword (keywordId) {
      this.npa.keyword = keywordId
    },
    getDataLinks (linkList) {
      this.links = linkList
    },
    getDataPersons(personList) {
      this.persons = personList
    },
    getDocsData (documentList) {
      this.documentsData = documentList
    },
    // Поле "Вид проекта" - если не выбрано (конституция, конституционный закон, кодекс или закон) очищаем выбранное значение у поля "initiator"
    changeNpaView(id) {
      if (!this.npaDataArray.viewIds.includes(id)) {
        this.viewIdsCompare = false
        this.npa.initiator = ''
      } else {
        this.viewIdsCompare = true
      }
    },
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    deletePerson(index) {
      if (!confirm(this.confirmMessage)) {
        return
      }
      this.npa.persons.splice(index, 1)
    },
    setInitiativeGroupDefaults() {
      this.npa.view = 4;
      this.npa.initiator = 7;
      this.npa.developer = 71;

      if (this.npaDataArray && this.npaDataArray.viewIds) {
        this.changeNpaView(4);
      }
    },
  }
}
</script>

<style scoped>
.entrepreneurship-hint {
  margin-top: 8px;
  margin-left: 35px;
  padding: 10px 12px;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.35;
  color: #d32f2f;
  background: #fff1f1;
  border-left: 4px solid #d32f2f;
  border-radius: 4px;
}
</style>
